module.exports = __webpack_public_path__ + "static/media/publishTop.1a95bd68.png";